import { render, staticRenderFns } from "./CommunityHomepageIcon.vue?vue&type=template&id=4f482d8e&scoped=true"
import script from "./CommunityHomepageIcon.vue?vue&type=script&lang=js"
export * from "./CommunityHomepageIcon.vue?vue&type=script&lang=js"
import style0 from "./CommunityHomepageIcon.vue?vue&type=style&index=0&id=4f482d8e&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4f482d8e",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/root/workspace/mall_vue_JOYE/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('4f482d8e')) {
      api.createRecord('4f482d8e', component.options)
    } else {
      api.reload('4f482d8e', component.options)
    }
    module.hot.accept("./CommunityHomepageIcon.vue?vue&type=template&id=4f482d8e&scoped=true", function () {
      api.rerender('4f482d8e', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/Decoration/PageDecoration/formList/CommunityHomepageIcon.vue"
export default component.exports